<!--
 * @Description: 
 * @Author: lmn
 * @Date: 2022-07-21 13:59:02
 * @LastEditors: lmn
 * @LastEditTime: 2022-07-22 11:30:29
-->
<!---/暂无数据-->
<template>
  <div
    class="emptyBox"
    :class="className"
    :style="{
      top: top + 'px',
      bottom: bottom + 'px',
      left: left + 'px',
      right: right + 'px'
    }"
  >
    <div class="con">
      <div class="img"></div>
      <span>{{ text }}</span>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    top: {
      type: Number,
      default() {
        return 0;
      }
    },
    bottom: {
      type: Number,
      default() {
        return 0;
      }
    },
    left: {
      type: Number,
      default() {
        return 0;
      }
    },
    right: {
      type: Number,
      default() {
        return 0;
      }
    },
    className: {
      // 自定义类名
      type: String,
      default() {
        return "";
      }
    },
    text: {
      type: String,
      default() {
        return "暂无数据";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.emptyBox {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none !important;
  .con {
    text-align: center;

    .img {
      width: 120px;
      height: 92px;
      display: block;
      margin: 0 auto;
      background:  url('../assets/imgs/no_data.png') no-repeat center;
      background-size: 100%;
    }

    span {
      display: block;
      font-size: 12px;
      line-height: 36px;
      color: #C8CCD7;
    }
  }
}
</style>
